import {
  WorkOrderData,
  WorkOrderStatus,
  ContractType,
  ContractWith,
  WorkOrderLineSource,
} from "../types";

// Mock data for Work Order widgets/KPIs
export const mockWorkOrderWidgetData = {
  totalWorkOrders: 156,
  draftCount: 12,
  draftPercentage: 7.7,
  pendingApprovalCount: 8,
  pendingApprovalPercentage: 5.1,
  rejectedCount: 3,
  rejectedPercentage: 1.9,
  approvedCount: 18,
  approvedPercentage: 11.5,
  releasedCount: 45,
  releasedPercentage: 28.8,
  inExecutionCount: 52,
  inExecutionPercentage: 33.3,
  onHoldCount: 6,
  onHoldPercentage: 3.8,
  completedCount: 8,
  completedPercentage: 5.1,
  closedCount: 4,
  closedPercentage: 2.6,
  totalWorkOrderValue: 45650000,
  paidToDate: 28950000,
  outstanding: 16700000,
  retentionBalance: 1450000,
  onHoldBalance: 750000,
  avgTimeToApprove: 3.2,
  avgTimeInExecution: 45.6,
};

// Mock work orders data
export const mockWorkOrdersData: WorkOrderData[] = [
  {
    id: "wo-001",
    workOrderNumber: "WO/2025-26/HYD/0042",
    linkedWorkRequest: "WR-1023",
    linkedTender: "TND-450",
    contractDate: "2025-08-01",
    contractorApplicationAccess: false,
    workOrderTitle: "Core & Shell - Tower B",
    workOrderDescription:
      "Complete structural work for Tower B including foundation and RCC work",
    siteId: "site-001",
    siteName: "HYD Site A",
    projectId: "proj-001",
    projectName: "Tower B",
    contractType: ContractType.Construction,
    contractWith: ContractWith.GeneralContractor,
    contractorId: "cont-001",
    contractorName: "Galaxy Infra",
    workOrderOwner: "John Smith",
    plannedStartDate: "2025-08-10",
    plannedEndDate: "2026-02-15",
    approvalRequired: true,
    enableTax: true,
    taxApplicationLevel: "Line Level",
    status: WorkOrderStatus.InExecution,
    totalValue: 1897280,
    taxAmount: 340000,
    grossValue: 2237280,
    createdAt: "2025-06-15",
    createdBy: "John Smith",
    updatedAt: "2025-07-20",
    workOrderLines: [
      {
        id: "wol-001",
        lineNumber: "WOL-001",
        workCategory: "Excavation",
        taskTitle: "Foundation Digging",
        taskDescription: "Basement Zone A trenching",
        quantity: 500,
        uom: "Cum",
        weightagePercentage: 15,
        rate: 120,
        taxType: "GST",
        taxPercentage: 18,
        taxAmount: 10800,
        totalAmount: 70800,
        source: WorkOrderLineSource.WorkBOQ,
        sourceId: "boq-001",
        executedQuantity: 310,
        remainingQuantity: 190,
        completionPercentage: 62,
      },
      {
        id: "wol-002",
        lineNumber: "WOL-002",
        workCategory: "RCC",
        taskTitle: "Roof Slab",
        taskDescription: "RCC slab casting",
        quantity: 250,
        uom: "Sqft",
        weightagePercentage: 25,
        rate: 150,
        taxType: "GST",
        taxPercentage: 18,
        taxAmount: 6750,
        totalAmount: 44250,
        source: WorkOrderLineSource.WorkBOQ,
        sourceId: "boq-002",
        executedQuantity: 180,
        remainingQuantity: 70,
        completionPercentage: 72,
      },
    ],
    generalConditions: [
      {
        id: "gc-001",
        conditionName: "Scope & Performance",
        conditionContent:
          "Defines the scope and performance obligations of contractor.",
        isActive: true,
        order: 1,
      },
      {
        id: "gc-002",
        conditionName: "Security Deposits",
        conditionContent:
          "Security deposit of 5% of contract value to be retained.",
        isActive: true,
        order: 2,
      },
    ],
    paymentConditions: {
      mobilizationAdvance: {
        isPercentOfContract: true,
        percentageOfContract: 10,
        interestCharged: true,
        interestRate: 12,
        recoveryType: "Each RA Bill",
      },
      retentionAmount: {
        isPercentOfRABill: true,
        percentageOfRABill: 5,
        dlpAmount: 5,
        dlpUnit: "months",
        releaseDate: "2026-01-06",
      },
      onHoldAmount: {
        isPercentOfContract: false,
        holdAmountValue: 50000,
        dlpAmount: 12,
        dlpUnit: "months",
        releaseDate: "2026-06-30",
      },
      payOnWorkCompletion: true,
    },
  },
  {
    id: "wo-002",
    workOrderNumber: "WO/2025-26/HYD/0031",
    contractDate: "2025-07-15",
    workOrderTitle: "Podium Finishes",
    workOrderDescription: "Interior and exterior finishing work for podium",
    siteId: "site-001",
    siteName: "HYD Site A",
    contractorApplicationAccess: false,
    projectId: "proj-002",
    projectName: "Tower A",
    contractType: ContractType.Construction,
    contractWith: ContractWith.SubContractor,
    contractorId: "cont-002",
    contractorName: "Alpha Constructions",
    workOrderOwner: "Jane Doe",
    plannedStartDate: "2025-08-01",
    plannedEndDate: "2025-12-31",
    approvalRequired: true,
    enableTax: true,
    status: WorkOrderStatus.OnHold,
    totalValue: 950000,
    taxAmount: 171000,
    grossValue: 1121000,
    createdAt: "2025-07-01",
    createdBy: "Jane Doe",
    workOrderLines: [
      {
        id: "wol-003",
        lineNumber: "WOL-003",
        workCategory: "Interior Finishing",
        taskTitle: "Wall Plastering",
        taskDescription: "Internal wall plastering work",
        quantity: 800,
        uom: "Sqft",
        weightagePercentage: 50,
        rate: 85,
        taxType: "GST",
        taxPercentage: 18,
        taxAmount: 8024,
        totalAmount: 52624,
        source: WorkOrderLineSource.WorkBOQ,
        sourceId: "boq-003",
        executedQuantity: 0,
        remainingQuantity: 800,
        completionPercentage: 0,
      },
    ],
    generalConditions: [
      {
        id: "gc-003",
        conditionName: "Quality Standards",
        conditionContent:
          "All work must comply with IS codes and quality standards.",
        isActive: true,
        order: 1,
      },
    ],
    paymentConditions: {
      mobilizationAdvance: {
        isPercentOfContract: true,
        percentageOfContract: 8,
        interestCharged: false,
        recoveryType: "Each RA Bill",
      },
      retentionAmount: {
        isPercentOfRABill: true,
        percentageOfRABill: 5,
        dlpAmount: 6,
        dlpUnit: "months",
        releaseDate: "2026-06-30",
      },
      onHoldAmount: {
        isPercentOfContract: false,
        holdAmountValue: 0,
        dlpAmount: 6,
        dlpUnit: "months",
        releaseDate: "2026-06-30",
      },
      payOnWorkCompletion: false,
    },
  },
  {
    id: "wo-003",
    workOrderNumber: "WO/2025-26/BLR/0018",
    contractDate: "2025-07-20",
    workOrderTitle: "MEP Package",
    workOrderDescription: "Mechanical, Electrical & Plumbing work",
    siteId: "site-002",
    siteName: "BLR Site C",
    projectId: "proj-003",
    projectName: "Tower C",
    contractorApplicationAccess: false,
    contractType: ContractType.Construction,
    contractWith: ContractWith.GeneralContractor,
    contractorId: "cont-003",
    contractorName: "Zenith MEP",
    workOrderOwner: "Mike Johnson",
    plannedStartDate: "2025-09-01",
    plannedEndDate: "2026-05-31",
    approvalRequired: true,
    enableTax: true,
    status: WorkOrderStatus.PendingApproval,
    totalValue: 2923729,
    taxAmount: 526271,
    grossValue: 3450000,
    createdAt: "2025-07-15",
    createdBy: "Mike Johnson",
    workOrderLines: [
      {
        id: "wol-005",
        lineNumber: "WOL-005",
        workCategory: "MEP",
        taskTitle: "Electrical Installation",
        taskDescription: "Main electrical panel and wiring",
        quantity: 1,
        uom: "Lot",
        weightagePercentage: 60,
        rate: 850000,
        taxType: "GST",
        taxPercentage: 18,
        taxAmount: 153000,
        totalAmount: 1003000,
        source: WorkOrderLineSource.WorkBOQ,
        sourceId: "boq-005",
        executedQuantity: 0,
        remainingQuantity: 1,
        completionPercentage: 0,
      },
    ],
    generalConditions: [
      {
        id: "gc-004",
        conditionName: "Safety Compliance",
        conditionContent:
          "Contractor must maintain all safety protocols as per OSHA guidelines.",
        isActive: true,
        order: 1,
      },
    ],
    paymentConditions: {
      mobilizationAdvance: {
        isPercentOfContract: true,
        percentageOfContract: 15,
        interestCharged: true,
        interestRate: 10,
        recoveryType: "Each RA Bill",
      },
      retentionAmount: {
        isPercentOfRABill: true,
        percentageOfRABill: 10,
        dlpAmount: 24,
        dlpUnit: "months",
        releaseDate: "2027-05-31",
      },
      onHoldAmount: {
        isPercentOfContract: false,
        holdAmountValue: 0,
        dlpAmount: 24,
        dlpUnit: "months",
        releaseDate: "2027-05-31",
      },
      payOnWorkCompletion: true,
    },
  },
  {
    id: "wo-004",
    workOrderNumber: "WO/2025-26/CHN/0025",
    contractDate: "2025-06-10",
    workOrderTitle: "Foundation Work Package",
    workOrderDescription:
      "Complete foundation work including excavation and concrete pouring",
    siteId: "site-003",
    contractorApplicationAccess: false,
    siteName: "Chennai Site D",
    projectId: "proj-004",
    projectName: "Residential Complex",
    contractType: ContractType.Construction,
    contractWith: ContractWith.GeneralContractor,
    contractorId: "cont-004",
    contractorName: "L&T Civil Infra",
    workOrderOwner: "Sarah Wilson",
    plannedStartDate: "2025-06-20",
    plannedEndDate: "2025-11-30",
    approvalRequired: false,
    enableTax: true,
    status: WorkOrderStatus.Completed,
    totalValue: 1800000,
    taxAmount: 324000,
    grossValue: 2124000,
    createdAt: "2025-06-01",
    createdBy: "Sarah Wilson",
    workOrderLines: [
      {
        id: "wol-006",
        lineNumber: "WOL-006",
        workCategory: "Foundation",
        taskTitle: "Concrete Pouring",
        taskDescription: "Foundation concrete work M25 grade",
        quantity: 120,
        uom: "Cum",
        weightagePercentage: 70,
        rate: 8500,
        taxType: "GST",
        taxPercentage: 18,
        taxAmount: 183600,
        totalAmount: 1203600,
        source: WorkOrderLineSource.WorkBOQ,
        sourceId: "boq-006",
        executedQuantity: 120,
        remainingQuantity: 0,
        completionPercentage: 100,
      },
    ],
    generalConditions: [
      {
        id: "gc-005",
        conditionName: "Material Quality",
        conditionContent:
          "All materials must be ISI marked and approved by consultant.",
        isActive: true,
        order: 1,
      },
    ],
    paymentConditions: {
      mobilizationAdvance: {
        isPercentOfContract: true,
        percentageOfContract: 12,
        interestCharged: true,
        interestRate: 11,
        recoveryType: "Each RA Bill",
      },
      retentionAmount: {
        isPercentOfRABill: true,
        percentageOfRABill: 5,
        dlpAmount: 12,
        dlpUnit: "months",
        releaseDate: "2026-11-30",
      },
      onHoldAmount: {
        isPercentOfContract: false,
        holdAmountValue: 25000,
        dlpAmount: 12,
        dlpUnit: "months",
        releaseDate: "2026-11-30",
      },
      payOnWorkCompletion: true,
    },
  },
  {
    id: "wo-005",
    workOrderNumber: "WO/2025-26/PUN/0012",
    contractDate: "2025-08-05",
    workOrderTitle: "Landscaping & External Works",
    workOrderDescription: "Garden development and external area finishing",
    siteId: "site-004",
    siteName: "Pune Site E",
    projectId: "proj-005",
    contractorApplicationAccess: false,
    projectName: "Commercial Plaza",
    contractType: ContractType.Service,
    contractWith: ContractWith.SubContractor,
    contractorId: "cont-005",
    contractorName: "Green Landscaping",
    workOrderOwner: "David Brown",
    plannedStartDate: "2025-08-15",
    plannedEndDate: "2025-10-15",
    approvalRequired: true,
    enableTax: true,
    status: WorkOrderStatus.Draft,
    totalValue: 680000,
    taxAmount: 122400,
    grossValue: 802400,
    createdAt: "2025-08-01",
    createdBy: "David Brown",
    workOrderLines: [
      {
        id: "wol-007",
        lineNumber: "WOL-007",
        workCategory: "Landscaping",
        taskTitle: "Garden Development",
        taskDescription: "Complete landscaping with plants and irrigation",
        quantity: 2000,
        uom: "Sqft",
        weightagePercentage: 80,
        rate: 250,
        taxType: "GST",
        taxPercentage: 18,
        taxAmount: 90000,
        totalAmount: 590000,
        source: WorkOrderLineSource.WorkBOQ,
        sourceId: "boq-007",
        executedQuantity: 0,
        remainingQuantity: 2000,
        completionPercentage: 0,
      },
    ],
    generalConditions: [
      {
        id: "gc-006",
        conditionName: "Environmental Compliance",
        conditionContent:
          "All landscaping work must comply with environmental regulations.",
        isActive: true,
        order: 1,
      },
    ],
    paymentConditions: {
      mobilizationAdvance: {
        isPercentOfContract: false,
        advanceValue: 50000,
        interestCharged: false,
        recoveryType: "Each RA Bill",
      },
      retentionAmount: {
        isPercentOfRABill: true,
        percentageOfRABill: 3,
        dlpAmount: 8,
        dlpUnit: "months",
        releaseDate: "2026-04-15",
      },
      onHoldAmount: {
        isPercentOfContract: false,
        holdAmountValue: 0,
        dlpAmount: 8,
        dlpUnit: "months",
        releaseDate: "2026-04-15",
      },
      payOnWorkCompletion: false,
    },
  },
];

// Mock status options
export const mockWorkOrderStatusOptions = [
  { label: "Draft", value: ["Draft"] },
  { label: "Pending Approval", value: ["Pending Approval"] },
  { label: "Rejected", value: ["Rejected"] },
  { label: "Approved", value: ["Approved"] },
  { label: "Released", value: ["Released"] },
  { label: "Contractor Confirmed", value: ["Contractor Confirmed"] },
  { label: "In Execution", value: ["In Execution"] },
  { label: "On Hold", value: ["On Hold"] },
  { label: "Variation Pending", value: ["Variation Pending"] },
  { label: "Amended", value: ["Amended"] },
  { label: "Completed", value: ["Completed"] },
  { label: "Closed", value: ["Closed"] },
  { label: "Cancelled", value: ["Cancelled"] },
];

// Mock contractor options
export const mockContractorOptions = [
  { label: "Galaxy Infra", value: "cont-001" },
  { label: "Alpha Constructions", value: "cont-002" },
  { label: "Zenith MEP", value: "cont-003" },
  { label: "L&T Civil Infra", value: "cont-004" },
  { label: "Green Landscaping", value: "cont-005" },
];

// Mock contract type options
export const mockContractTypeOptions = [
  { label: "Construction", value: "Construction" },
  { label: "Service", value: "Service" },
  { label: "Maintenance", value: "Maintenance" },
  { label: "Others", value: "Others" },
];

// Function to get work order by ID
export const getWorkOrderById = (id: string): WorkOrderData | null => {
  const workOrder = mockWorkOrdersData.find((wo) => wo.id === id);
  return workOrder || null;
};
